export const GCAL_COLORS = {
  "1": { name: "Lavender", hex: "#7986cb" },
  "2": { name: "Sage", hex: "#33b679" },
  "3": { name: "Grape", hex: "#8e24aa" },
  "4": { name: "Flamingo", hex: "#e67c73" },
  "5": { name: "Banana", hex: "#f6bf26" },
  "6": { name: "Tangerine", hex: "#f4511e" },
  "7": { name: "Peacock", hex: "#039be5" },
  "8": { name: "Graphite", hex: "#616161" },
  "9": { name: "Blueberry", hex: "#3f51b5" },
  "10": { name: "Basil", hex: "#0b8043" },
  "11": { name: "Tomato", hex: "#d50000" },
};

export const colorHex = (id) => GCAL_COLORS[id]?.hex || "#D4AF37";

export const ColorPicker = ({ value, auto, onChange }) => (
  <div data-testid="service-color-picker">
    <span className="text-white/60 text-xs uppercase tracking-wide font-mono-label mb-2 block">
      Calendar color — {value ? GCAL_COLORS[value]?.name : `Auto (${GCAL_COLORS[auto]?.name || "Peacock"})`}
    </span>
    <div className="flex flex-wrap gap-2 items-center">
      <button type="button" onClick={() => onChange("")} data-testid="color-auto"
        className={`px-2.5 h-7 rounded-full text-[10px] uppercase font-mono-label border ${!value ? "border-[#D4AF37] text-[#D4AF37]" : "border-white/15 text-white/50"}`}>Auto</button>
      {Object.entries(GCAL_COLORS).map(([id, c]) => (
        <button key={id} type="button" title={c.name} onClick={() => onChange(id)} data-testid={`color-${id}`}
          className={`h-7 w-7 rounded-full transition-transform hover:scale-110 ${value === id ? "ring-2 ring-white ring-offset-2 ring-offset-[#0a0a0a]" : ""}`}
          style={{ backgroundColor: c.hex }} />
      ))}
    </div>
  </div>
);
